<template>
  <BillingDialog class="zdocs-plan-details" v-model="visible" show-close @back-event="handleBeforeClose" :before-close='handleBeforeClose'>
    <h1 class="zdocs-plan-details__title">
      {{ title }}
    </h1>
    <price-list
      class="zdocs-plan-details__price-list"
      :showDecimalPoint="is_desktop_reactive"
      :plan-category="planCategory"
      :unit-type="planUnitMap.license"
    />
    <ul class="zdocs-plan-details__desc">
      <li v-for="item in descList" :key="item">
        <span>{{ item }}</span>
      </li>
    </ul>
  </BillingDialog>
</template>

<script>
import { ConfirmComponent } from '@/components/common/service-dialog/confirm';
import PriceList from '@/components/price-list.vue';
import { planUnitMap } from '@/common/product-unit';
import BillingDialog from '@/components/billing-dialog.vue';

export default {
  name: 'ZoomDocsPlanDetails',
  mixins: [ConfirmComponent],
  components: {
    PriceList,
    BillingDialog,
  },
  props: {
    title: String,
    planCategory: String,
    trackingPlanName: String,
  },
  data() {
    return {
      visible: false,
      planUnitMap,
      descList: [
        this.$t('billing.docs.features_item1'),
        this.$t('billing.zoom_docs.plan_details.desc2'),
        this.$t('billing.zoom_docs.plan_details.desc3'),
        this.$t('billing.zoom_docs.plan_details.desc4'),
      ],
    };
  },
  watch: {
    /**
     * watch visible and fire event
     * @param {boolean} val visible
     */
    visible(val) {
      this.$tracking.buyInteraction('plan details', `${this.trackingPlanName} plan details - ${val ? 'impression' : 'exit'}`);
    },
  },
  methods: {
    handleBeforeClose() {
      this.visible = false;
    }
  }
};
</script>

<style lang="scss">
@import '@zoom/billing-responsive/styles/responsive.scss';
.zdocs-plan-details {
  &.zbo-dialog {
    min-width: 576px;
    width: fit-content;
  }
  .zbo-dialog__header {
    padding: 24px 0 16px;
  }
  &__title {
    color: var(--zoom-color-text-stronger-neutral, #2A2B2D);
    font-size: 22px;
    font-weight: 700;
    line-height: 1.5em;
  }

  &__price-list {
    margin-bottom: 4px;
    padding: 8px 0;
    @include media(mobile, tablet) {
      margin-top: 4px;
    }
  }

  &__desc {
    list-style-image: url('../../../../assets/plans/check.svg');
    color: var(--zoom-color-text-stronger-neutral, #2A2B2D);
    font-size: 14px;
    font-weight: 400;
    line-height: 1.5em;
    margin-left: 15px;
    > li {
      margin-bottom: 16px;
      &:last-child {
        margin-bottom: 0;
      }
      span {
        position: relative;
        left: 4px;
      }
    }
  }
}
</style>
